import { CommentsTab } from "./CommentsTab";
import {
  useCreateMeasurementRequestComment,
  useDeleteMeasurementRequestComment,
} from "@/hooks/useMeasurementRequestComments";
import { MeasurementRequest } from "@/types/measurementRequest";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsTrigger, TabsList } from "@/components/ui/tabs";
import { COMMENT_TAB_ID, LOG_EVENT_TAB_ID } from "../MeasurementRequestDetails.values";
import { Measurement } from "@/types/measurement";
import { MeasurementLogEventDisplay } from "../MeasurementRequestDetails.types";
import { LogEventsTab } from "./LogEventsTab";

type MeasurementRequestMessagesProps = {
  measurementRequest: MeasurementRequest;
  refetch: () => void;
  measurements: Measurement[];
};

export const MeasurementRequestMessages = ({
  measurementRequest,
  refetch,
  measurements,
}: MeasurementRequestMessagesProps) => {
  const { trigger: createComment, isMutating: isCreatingComment } =
    useCreateMeasurementRequestComment(measurementRequest.id);
  const { trigger: deleteComment } = useDeleteMeasurementRequestComment(measurementRequest.id);

  const logEvents: MeasurementLogEventDisplay[] = measurements.flatMap((m) =>
    m.logEvents.map((e) => ({ ...e, measurementId: m.id, timestamp: m.timestamp })),
  );
  const handleCreateComment = async (comment: string) => {
    await createComment(
      { comment },
      {
        onSuccess: () => {
          refetch();
        },
      },
    );
  };

  const handleDeleteComment = async (commentId: number) => {
    await deleteComment(
      { id: commentId },
      {
        onSuccess: () => {
          refetch();
        },
      },
    );
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Messages</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Tabs defaultValue={COMMENT_TAB_ID}>
          <TabsList>
            <TabsTrigger key={COMMENT_TAB_ID} value={COMMENT_TAB_ID}>
              Comments
            </TabsTrigger>
            <TabsTrigger key={LOG_EVENT_TAB_ID} value={LOG_EVENT_TAB_ID}>
              Log Events
            </TabsTrigger>
          </TabsList>
          <CommentsTab
            allowCreate
            comments={measurementRequest.comments}
            isCreatingComment={isCreatingComment}
            onCreateComment={handleCreateComment}
            onDeleteComment={handleDeleteComment}
          />
          <LogEventsTab logEvents={logEvents} />
        </Tabs>
      </CardContent>
    </Card>
  );
};
